<section *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" [formGroup]="formElectronicInvoiceInterface">
        <div class="ps-2 pe-2">
          <div class="row pt-1">
            <div class="col">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                [width]="'6rem'" (onClick)="goToBack($event)" [severity]="null"></app-custom-button>
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>

            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
              <app-custom-button [title]="buttonText" [label]="buttonText" (onClick)="openSynchronizer()"
                [severity]="'success'" [width]="'6.5rem'" [icon]="'pi pi-sync'"
                [variant]="undefined"></app-custom-button>
              <app-custom-modal #synchronizer [header]="'Sincronizador'" [children]="componentSynchronizer"
                [closable]="true" [width]="'55vw'" [inputs$]="inputsForSynchronizer$" [output$]="outputForSynchronizer$"
                hidden></app-custom-modal>
            </div>
            <hr class="my-1">
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-audit-info [userNameCreate]="electronicInvoiceInterfaceContract.userNameCreate"
                [createDate]="electronicInvoiceInterfaceContract.createDate"
                [userNameUpdate]="electronicInvoiceInterfaceContract.userNameUpdate"
                [updateDate]="electronicInvoiceInterfaceContract.updateDate"
                [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
          <div class="row mt-1 d-flex justify-content-between">
            <div class="col-lg-12 col-md-6 col-sm-12 col-12 pe-md-2">
              <div class="row">
                <div class="col-lg-2 col-md-12 col-sm-4 col-6">
                  <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                    [required]="true" [recovery]="true" (onChangeSelect)="getBranch($event, true)"></app-custom-select>
                </div>
                <div class="col-lg-2 col-md-12 col-sm-4 col-6">
                  <app-custom-select formControlName="enterpriseId" [labelText]="'Empresa'" [list]="listEnterprises"
                    [required]="true" [recovery]="true"
                    (onChangeSelect)="getEnterprise($event, true)"></app-custom-select>
                </div>
                <div class="col-lg-1 col-md-4 col-sm-2 col-6">
                  <app-custom-input-number formControlName="consecutive" [labelText]="'Número'" [required]="true"
                    [recovery]="true" (onChangeNumber)="changeConsecutive()"></app-custom-input-number>
                </div>
                <div class="col-lg-1 col-md-4 col-sm-3 col-6">
                  <app-custom-datepicker formControlName="dateInterface" [labelText]="'Fecha'"
                    [required]="true"></app-custom-datepicker>
                </div>
                <div class="col-lg-5 col-md-12 col-sm-12 col-12">
                  <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [rows]="1"
                    [autoResize]="false" [maxLength]="50"></app-custom-textarea>
                </div>
                <div class="col-lg-1 col-md-3 col-sm-3 col-6">
                  <app-custom-tag [label]="'Estado'" [severity]="severityState" [value]="stateText"></app-custom-tag>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <app-electronic-invoice-interface-detail [electronicInvoiceInterfaceModel]="electronicInvoiceInterfaceContract"
      [companyId]="companyId" [permissionUpdatable]="permissionUpdatable" [listBranches]="listBranches"
      [listEnterprises]="listEnterprises"></app-electronic-invoice-interface-detail>
  </div>
</section>

<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>
    No se permite tener dos ventanas/pestañas de {{ nameWindow }} abiertas.
  </h6>
</div>